import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { CrmFieldFilter, CrmFilterField } from "types/Models/crmFields";
import { CrmConditionControl } from "./CrmConditionControl";

type CrmConditionRowProps = {
  field: CrmFilterField;
  condition: CrmFieldFilter;
  onChange: (condition: CrmFieldFilter) => void;
  onRemove: (fieldKey: string) => void;
};

export const CrmConditionRow = ({
  field,
  condition,
  onChange,
  onRemove,
}: CrmConditionRowProps) => {
  const handleRemove = () => {
    onRemove(field.field_key);
  };

  return (
    <div className="t-flex t-gap-3 t-items-center t-w-full">
      <div className="t-w-48 t-shrink-0 t-text-body-sm t-text-text-60 t-truncate">
        {field.label}
      </div>

      <div className="t-grow t-min-w-0">
        <CrmConditionControl
          field={field}
          condition={condition}
          onChange={onChange}
        />
      </div>

      <Button
        type="button"
        size="small"
        customType="ghost_icon"
        onClick={handleRemove}
        aria-label={`Remove ${field.label} filter`}
      >
        <Cross />
      </Button>
    </div>
  );
};
